import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-839cb448"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "home"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = {
  class: "bottom-bar"
};

const _hoisted_4 = /*#__PURE__*/_createTextVNode("首页");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("我的");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_view = _resolveComponent("router-view");

  const _component_van_tabbar_item = _resolveComponent("van-tabbar-item");

  const _component_van_tabbar = _resolveComponent("van-tabbar");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_router_view, null, {
    default: _withCtx(({
      Component
    }) => [(_openBlock(), _createBlock(_KeepAlive, {
      include: _ctx.includeRoutes
    }, [(_openBlock(), _createBlock(_resolveDynamicComponent(Component)))], 1032, ["include"]))]),
    _: 1
  })]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_van_tabbar, {
    modelValue: _ctx.active,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.active = $event),
    "active-color": "#85a5ff"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_tabbar_item, {
      name: "/home",
      icon: "home-o"
    }, {
      default: _withCtx(() => [_hoisted_4]),
      _: 1
    }), _createVNode(_component_van_tabbar_item, {
      name: "/about",
      icon: "award"
    }, {
      default: _withCtx(() => [_hoisted_5]),
      _: 1
    })]),
    _: 1
  }, 8, ["modelValue"])])]);
}